import React from 'react';

const Services: React.FC = () => {
  const services = [
    {
      icon: '🛡️',
      title: 'ระบบเพื่อความปลอดภัย',
      description: 'CCTV, Smart Home IoT, Barrier System, Access Control',
      features: [
        'CCTV System ทุกประเภท',
        'Smart Home (IoT)',
        'Barrier System & Access Control',
        'Hotel/Fitness/Spa Solutions'
      ]
    },
    {
      icon: '⚡',
      title: 'ระบบพลังงาน',
      description: 'Solar Cell และโซลูชันพลังงานสะอาด',
      features: [
        'อุปกรณ์คุณภาพสูง',
        'ทีมงานติดตั้งมืออาชีพ',
        'ลดค่าใช้จ่ายพลังงาน',
        'รับประกันคุณภาพ'
      ]
    },
    {
      icon: '🌐',
      title: 'Network & Internet',
      description: 'ระบบเครือข่ายและอินเทอร์เน็ตครบวงจร',
      features: [
        'ออกแบบ/ติดตั้งระบบเครือข่าย',
        'Fiber Optic / LAN Cabling',
        'WiFi Solutions',
        'Firewall & Security'
      ]
    },
    {
      icon: '💻',
      title: 'Software & Application',
      description: 'พัฒนาเว็บไซต์ แอปพลิเคชัน และระบบงาน',
      features: [
        'Web & Mobile Application',
        'Line OA & AI Application',
        'ERP Integration',
        'Smart Room & Smart City'
      ]
    },
    {
      icon: '📺',
      title: 'IPTV & Digital Signage',
      description: 'ระบบทีวีและป้ายดิจิทัลสำหรับองค์กร',
      features: [
        'IPTV สำหรับโรงพยาบาล',
        'Digital Signage โรงแรม',
        'ระบบกระจายสัญญาณ',
        'การจัดการเนื้อหา'
      ]
    },
    {
      icon: '🏢',
      title: 'กลุ่มลูกค้า',
      description: 'ให้บริการหลากหลายอุตสาหกรรม',
      features: [
        'งานราชการ',
        'โรงแรม / รีสอร์ท',
        'โรงงาน / โรงพยาบาล',
        'สถานศึกษา'
      ]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-napa-blue-800 mb-4">
            บริการของเรา
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ให้บริการโซลูชันครบวงจรด้วยเทคโนโลยีที่ทันสมัย 
            และทีมงานมืออาชีพที่มีประสบการณ์
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg card-hover border border-gray-100"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-napa-blue-800 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <svg className="w-4 h-4 text-napa-blue-500 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-napa-blue-600 to-napa-blue-800 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">
              พร้อมให้คำปรึกษาและออกแบบโซลูชันที่เหมาะสม
            </h3>
            <p className="text-blue-100 mb-6">
              ทีมงานมืออาชีพของเราพร้อมให้บริการและสนับสนุนทุกความต้องการ
            </p>
            <a
              href="#contact"
              className="bg-white text-napa-blue-800 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-300 transform hover:scale-105 inline-block"
            >
              ขอใบเสนอราคา
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
